import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import Button from '../Button';
import { openModal as openModalAction } from '../../../actions/modal-actions';
import WarningIcon from '../../icons/WarningIcon';
import { REPORT_PHOTO_MODAL } from '../../../constants/modals';

const propTypes = {
  albumId: PropTypes.string,
  onClick: PropTypes.func,
  photoId: PropTypes.string.isRequired,
  requestConfirm: PropTypes.func,
  reportedPhotosCreateMutation: PropTypes.func,
  children: PropTypes.func,
  authenticated: PropTypes.bool,
  openModal: PropTypes.func,
};

const ReportPhotoButton = ({
  albumId,
  onClick,
  photoId,
  requestConfirm,
  reportedPhotosCreateMutation,
  children,
  authenticated,

  staticContext,
  openModal,
  ...btnProps
}) => {
  const btnRef = useRef(null);

  if (!photoId || !authenticated) {
    return null;
  }

  return (
    <Button
      onClick={() =>
        openModal(REPORT_PHOTO_MODAL, {
          albumId,
          photoId,
        })
      }
      btnStyle="glass"
      {...btnProps}
      disabled={btnProps?.disabled}
      inputRef={btnRef}
      data-for={`tooltip-report-${photoId}`}
      data-effect="solid"
    >
      {children || <WarningIcon color="#fff" size="24" />}
    </Button>
  );
};

ReportPhotoButton.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const mapDispatchToProps = {
  openModal: openModalAction,
};

export { ReportPhotoButton as ReportPhotoButtonComp };

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(ReportPhotoButton);
